module.exports = __webpack_public_path__ + "static/media/linkedinIcon.0e01bf57.svg";